"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGroups = void 0;
const lodash_1 = __importDefault(require("lodash"));
const mapGroups = (groupActuators, groupDevices) => lodash_1.default.compact(groupActuators.map((za) => {
    const groupDevice = groupDevices.find((zd) => za.deviceId === zd.id);
    if (groupDevice) {
        return Object.assign(Object.assign({}, za), { groupMeshId: groupDevice.mesh.uniqueId, associatedDevices: Object.keys(groupDevice.model.deviceIds), name: groupDevice.name });
    }
    return undefined;
}));
exports.mapGroups = mapGroups;
//# sourceMappingURL=Groups.js.map